import { Controller } from "stimulus"

/**
 * テーブル一覧／テーブルの管理
 */
export default class extends Controller {
  /**
   * 「テーブルの開始」モーダル表示
   */
  openSeatGroupStartModal(event) {
    const seatGroupId = event.target.getAttribute('data-seat-group-id');
    const seatGroupStartModalId = "#seat-group-start-modal-" + seatGroupId;
    const seatGroupStatusModalId = "#seat-group-status-modal-" + seatGroupId;
    $(seatGroupStartModalId).modal('show');
    $(seatGroupStatusModalId).modal('hide');
  }

  /**
   * 「テーブルの変更」モーダル表示
   */
  openChangeSeatGroupModal(event) {
    const seatGroupId = event.target.getAttribute('data-seat-group-id');
    // 変更先のテーブルの初期値を表示先のモーダルに反映する処理
    this.changeSeatGroup(seatGroupId);

    const changeSeatGroupModalId = "#swap-seat-group-modal-" + seatGroupId;
    const seatGroupStatusModalId = "#seat-group-status-modal-" + seatGroupId;
    $(changeSeatGroupModalId).modal('show');
    $(seatGroupStatusModalId).modal('hide');
  }

  /**
   * 「テーブルステータスの変更」モーダル表示
   */
  openChangeStatusModal(event) {
    const seatGroupId = event.target.getAttribute('data-seat-group-id');
    const changeStatusModalId = "#update-status-modal-" + seatGroupId;
    const seatGroupStatusModalId = "#seat-group-status-modal-" + seatGroupId;
    $(changeStatusModalId).modal('show');
    $(seatGroupStatusModalId).modal('hide');
  }

  /**
   * テーブルステータスの変更
   */
  changeStatus(event) {
    const seatGroupId = event.target.getAttribute('data-seat-group-id');
    const selectStatus = document.getElementById("select-status-" + seatGroupId);

    selectStatus.addEventListener("change", function() {
      const selectedValue = selectStatus.value;
      const hiddenFieldStatusId = "update-status-" + seatGroupId;
      document.getElementById(hiddenFieldStatusId).value = selectedValue;
    });
  }

  /**
   * テーブルの変更
   */
  changeSeatGroup(seatGroupId) {
    const selectName = document.getElementById("select-seat-group-" + seatGroupId);
    const selectedValue = selectName.value;
    const selectedKey = selectName.options[selectName.selectedIndex].textContent;
    const hiddenFieldNameId = "hidden-swap-seat-group-" + seatGroupId;
    const displayedNameFieldNameId = "swap-seat-group-" + seatGroupId;
    document.getElementById(hiddenFieldNameId).value = selectedValue;
    document.getElementById(displayedNameFieldNameId).textContent = selectedKey;
  }

  /**
   * 案内可能になるまでの時間の変更モーダル表示
   */
  openUpdateStatusIntervalModal(event) {
    event.preventDefault();

    $('#update-seat-group-status-interval-modal').modal('show');
  }

  /**
   * 「注文を見る」モーダル表示
   */
  openSeatGroupOrderModal(event) {
    event.preventDefault();

    const seatGroupId = event.target.getAttribute('data-seat-group-id');
    const seatGroupOrderModalId = "#seat-group-order-modal-" + seatGroupId;
    $(seatGroupOrderModalId).modal('show');
  }

  /**
   * 「QRコード再発行」モーダル表示
   */
  openQrReissueModal(event) {
    const seatGroupId = event.target.getAttribute('data-seat-group-id');
    const seatGroupQrReissueModalId = "#seat-group-qr-reissue-modal-" + seatGroupId;
    const seatGroupStatusModalId = "#seat-group-status-modal-" + seatGroupId;
    $(seatGroupQrReissueModalId).modal('show');
    $(seatGroupStatusModalId).modal('hide');
  }

  /**
   * 「決済内容の確認」モーダル表示
   */
  openConfirmPaymentModal(event) {
    const seatGroupId = event.target.getAttribute('data-seat-group-id');
    const modalId = "#seat-group-confirm-payment-modal-" + seatGroupId;
    const seatGroupStatusModalId = "#seat-group-status-modal-" + seatGroupId;
    $(modalId).modal('show');
    $(seatGroupStatusModalId).modal('hide');
  }
}
